export enum ErrorKeyValue {
  // # 600 ~ 699 資料異常
  INVALID_FIELDS = 600,
  INVALID_EFFECTIVE_DATE = 601,
  INVALID_EST_ARRIVED_DATE = 602,
  INVALID_LENGTH = 603,
  INVALID_OPERATION = 604,
  INVALID_DATE = 605,
  INVALID_NUM = 606,

  // # 700 ~ 799 不存在
  NOT_EXIST = 700,
  NOT_EXIST_REQUIRED_FIELDS = 701,
  NOT_EXIST_PRODUCT = 702,
  NOT_EXIST_VPC = 703,
  NOT_EXIST_SHIPPING_METHOD = 704,
  NOT_EXIST_WAREHOUSE = 705,
  NOT_EXIST_PLATFORM = 706,
  ALREADY_EXIST = 750,

  // # 800 ~ 899 其他類別
  DUPLICATE_PRODUCT = 801,
  ORDER_HAS_DEPLOYED = 805,
  STOCK_NOT_ENOUGH = 810,

  // # 900 ~ 999 系統維護
  MAINTENANCE = 901,
}

export const ErrorKeyValueMap: { [key: number]: string } = {
  [ErrorKeyValue.INVALID_FIELDS]: "欄位異常",
  [ErrorKeyValue.INVALID_EFFECTIVE_DATE]: "有效日期異常",
  [ErrorKeyValue.INVALID_EST_ARRIVED_DATE]: "預計到貨日期異常",
  [ErrorKeyValue.INVALID_LENGTH]: "長度異常",
  [ErrorKeyValue.INVALID_OPERATION]: "操作異常",
  [ErrorKeyValue.INVALID_DATE]: "日期異常",
  [ErrorKeyValue.INVALID_NUM]: "數字異常",
  [ErrorKeyValue.NOT_EXIST]: "不存在",
  [ErrorKeyValue.NOT_EXIST_REQUIRED_FIELDS]: "必填欄位未填寫",
  [ErrorKeyValue.NOT_EXIST_PRODUCT]: "商品不存在",
  [ErrorKeyValue.NOT_EXIST_VPC]: "VPC不存在",
  [ErrorKeyValue.NOT_EXIST_SHIPPING_METHOD]: "運送方式不存在",
  [ErrorKeyValue.NOT_EXIST_WAREHOUSE]: "倉庫不存在",
  [ErrorKeyValue.DUPLICATE_PRODUCT]: "商品重複",
  [ErrorKeyValue.ORDER_HAS_DEPLOYED]: "訂單已拋單",
  [ErrorKeyValue.STOCK_NOT_ENOUGH]: "庫存不足",
  [ErrorKeyValue.MAINTENANCE]: "系統維護",
};

// 後端客製化錯誤代碼
export enum StatusCode {
  TOKEN_EXPIRED = 4002,
  UNKNOWN_ERROR = 9001,
  NOT_EXIST = 9003,
}
